import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { getContent } from '@/utils/helper';
import { analytics, getCowNavigation } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import CutsNavigationDD from './CutsNavigationDD';

function CutsHeaderDD({ assets = [], entries = [], fields = null }) {
  const cowRef = useRef(null);
  const cutDescriptionRef = useRef(null);
  const cowSvgRef = useRef(null);

  const { title, subtitle, backgroundImage, cuts } = fields;
  const bg = getContent(backgroundImage?.sys.id, assets);

  const handleCowNavigation = (e, part) => {
    analytics({
      window,
      document,
      detail: getCowNavigation(e, {
        part,
      }),
    });
  };

  useEffect(() => {
    if (cowRef && cutDescriptionRef) {
      // centering cut on mobile
      if (window?.innerWidth < 768) {
        cowRef.current.style.height = `fit-content`;
        cowSvgRef.current.style.height = `fit-content`;
      }
    }
  }, [cowRef, cutDescriptionRef, cowSvgRef]);

  return (
    <div className="flex flex-col h-full w-full">
      <div
        className="aaco-header aaco-cuts-header h-auto md:h-[100vh] bg-progressive-blue relative md:mb-[15vh]"
        aria-label={title}
      >
        <div className="aaco-header__content container mx-auto text-white text-center flex flex-col relative h-full">
          <div className="aaco-header__titles w-full relative text-center">
            <Text
              tag="h2"
              style={`text-center mt-10 md:mt-12 mb-2 text-transparent bg-clip-text bg-quality-gold`}
            >
              {title}
            </Text>
            {subtitle && (
              <div className="font-text text-body mx-auto text-white mt-5 md:w-1/2">
                {subtitle}
              </div>
            )}
          </div>
          <div
            className="aaco-header__image-desktop h-fit md:h-[1px] md:flex-1 pt-5 md:pt-2 flex justify-center md:relative items-center"
            ref={cowRef}
          >
            <CutsNavigationDD
              svgRef={cowSvgRef}
              backgroundSrc={bg.fields.file.url}
              cuts={cuts}
              entries={entries}
              handleCowNavigation={handleCowNavigation}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

// @TODO: define real props for the Header based on it requirements
CutsHeaderDD.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  fields: PropTypes.object,
  slug: PropTypes.string,
};

export default CutsHeaderDD;
